@if (workshop) {
  <div class="m-3!">
    <h5>
      {{ workshop.title }}
    </h5>
    <section
      class="bg-white bg-opacity-50 rounded d-flex justify-content-around p-2 p-lg-3"
    >
      <div class="d-flex align-items-center justify-content-center gap-2">
        <ng-icon
          name="lucideLayers"
          class="fs-5 text-muted opacity-50"
        ></ng-icon>
        <span class="text-muted">{{ workshop.holdingTypeTitle }}</span>
      </div>
      <div></div>
      <div class="d-flex align-items-center justify-content-center gap-2">
        <ng-icon
          name="lucideClock"
          class="fs-5 text-muted opacity-50"
        ></ng-icon>
        <span class="text-muted">{{ workshop.holdingDateJalali }}</span>
      </div>
    </section>
    <section class="d-flex justify-content-center">
      @if (workshop.coverImage) {
        <afra-image
          class="cover-img"
          [fileId]="workshop.coverImage"
          alt="workshop cover image"
        ></afra-image>
      } @else {
        <img
          class="cover-img"
          src="/assets/images/video_cover.png"
          alt="workshop cover image"
        />
      }
    </section>
    <section>
      <div
        class="text-justify"
        [innerHTML]="workshop.description | safeHtml"
      ></div>
    </section>
    @if (workshop.prerequisites?.length) {
      <section class="mt-8!">
        <h6>پیش‌نیاز ها</h6>
        <div class="bg-white rounded shadow-sm p-4">
          @for (pre of workshop.prerequisites; track $index) {
            <div class="flex items-center mb-2 gap-2">
              <i class="pi pi-circle-fill text-[8px]! text-surface-700"></i>
              @switch (pre.type) {
                @case (1) {
                  {{ pre.displayTitle }}
                }
                @case (2) {
                  <a
                    [routerLink]="[
                      '/e-workshop',
                      'e-workshops',
                      pre.workshopId,
                      pre.videoId,
                    ]"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {{ pre.displayTitle }}
                  </a>
                }
                @case (3) {
                  <a
                    [href]="pre.link"
                    target="_blank"
                    rel="noopener noreferrer"
                    (click)="openInNewTab(pre.link, $event)"
                  >
                    {{ pre.displayTitle }}
                  </a>
                }
              }
            </div>
          }
        </div>
        <div class="my-5"></div>
      </section>
    }
    <form [formGroup]="form">
      <div *ngIf="workshop">
        <h5>{{ "فرم ثبت‌نام" }}</h5>
        <div class="row mt-4">
          <div class="col-12 col-md-6">
            <label class="form-label">{{ attendanceTypeLabel }}</label>
            <dx-select-box
              [items]="workshop?.holdingType"
              displayExpr="title"
              valueExpr="id"
              formControlName="attendanceTypeId"
            ></dx-select-box>
          </div>
          <div class="col-12 col-md-6 mt-4 mt-md-0">
            <label class="form-label">{{ informWayLabel }}</label>
            <dx-select-box
              [items]="informWays"
              displayExpr="title"
              valueExpr="id"
              formControlName="informWayId"
            ></dx-select-box>
          </div>
          <div class="col-12 mt-4" *ngIf="workshop?.hasQuestionBox">
            <label class="form-label"
              >فراگیر گرامی؛ برای برگزاری هرچه بهتر کارگاه و ارائه پاسخ مناسب،
              لطفاً پرسش‌های خود را از طریق قسمت زیر ارسال کنید تا در کارگاه به
              آن‌ها پاسخ دهیم.</label
            >
            <dx-text-area
              formControlName="questions"
              [height]="'130px'"
            ></dx-text-area>
          </div>
          <div class="col-12 mt-4" *ngIf="workshop?.showMotivationLetter">
            <label class="form-label">انگیزه‌نامه</label>
            <dx-text-area
              formControlName="motivation_letter"
              [height]="'130px'"
            ></dx-text-area>
          </div>
        </div>
        <div class="mt-3 lh-lg">
          <dx-check-box
            rtlEnabled="true"
            formControlName="confirmed"
          ></dx-check-box>
          <span class="ms-2">{{ registerPromptLabel }}</span>
        </div>
      </div>
      <div class="flex mt-4 pb-4 gap-3">
        <button
          pButton
          severity="primary"
          class="flex align-items-center"
          (click)="onRegister()"
          [disabled]="!form?.valid"
        >
          <span class="fa fa-check me-1" pButtonIcon></span>
          <span pButtonLabel>
            {{ isPreRegister ? "پیش ثبت‌نام" : registerLabel }}
          </span>
        </button>
        @if (!isPreRegister) {
          <a
            [href]="workshop.googleCalendarNewEventUrl"
            target="_blank"
            pButton
            class="flex align-items-center no-underline!"
            text
          >
            <span class="fa fa-calendar me-1" pButtonIcon></span>
            <span pButtonLabel> افزودن به تقویم </span>
          </a>
        }
      </div>
    </form>
    <section class="mt-3">
      <h6>درباره استاد</h6>
      <div
        *ngFor="let t of workshop.teachers; let i = index"
        class="p-3 p-lg-4 m-2"
      >
        <div class="d-flex align-items-center">
          <afra-image
            *ngIf="t.avatar"
            class="teacher-img"
            [fileId]="t.avatar"
            alt=""
          ></afra-image>
          <ng-icon
            *ngIf="!t.avatar"
            name="lucideUserCircle"
            class="teacher-img me-2 text-secondary"
          ></ng-icon>

          <div class="ms-3">
            <div>{{ t.name }}</div>
            <div>{{ t.position }}</div>
            <div class="text-muted">
              <i class="fa fa-cubes-stacked"></i>
              &nbsp;
              <span>{{ t.workshopsCount }}</span>
              کارگاه
            </div>
          </div>
        </div>
        <div class="mt-3 text-justify preserve-lines">{{ t.bio }}</div>
      </div>
    </section>
  </div>
}
